var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-breadcrumb',{attrs:{"separator":"/"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/home' }}},[_vm._v("首页")]),_c('el-breadcrumb-item',[_vm._t("firstMenu",function(){return [_vm._v("一级菜单")]})],2),_c('el-breadcrumb-item',[_vm._t("secondMenu",function(){return [_vm._v("二级菜单")]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }